import React from 'react';

const ChannelEditorialResponsibilities = () => {
  return (
    <React.Fragment>
      <h1>Channel Responsibilities</h1>

      <p>
        <strong>Channel Curators</strong> and qualified <strong>Channel Admins</strong> assess all article submissions during two distinct steps in the article publication process. All articles must be reviewed within seven days of submission. <strong>Independent Cureus editors (associate editors)</strong> make the final decision to publish or reject each article.
      </p>

      <p>
        <strong>Channel Screeners</strong> are not involved in any aspect of the editorial or publishing process. They simply determine whether a newly submitted article belongs in the channel. If so, the article proceeds for review by an independent Cureus editor. If not, the article is removed from the channel before proceeding for Cureus review.
      </p>

      <p>
        <strong>First Channel Preview:</strong> These manuscripts have just been submitted, and the Channel Curator is responsible for reviewing each submission to ensure the following:
      </p>

      <ul className='disc indented-for-medium-up'>
        <li>The article is submitted by a channel member or otherwise approved author, and the topic and scope of the article fits within the channel.</li>
        <li>The article contains credible science with all necessary ethical and registration procedures followed.</li>
        <li>The article is well-written and does not require extensive language editing.</li>
        <li>The article is formatted according to the Cureus Author Guide.</li>
      </ul>

      <p>Articles in need of revision must be deferred back to the authors with a complete list of required changes.</p>

      <p><strong>Second Channel Preview:</strong> These manuscripts have already undergone initial review by the channel and journal and have also completed independent peer review. The authors have revised the manuscript based on the peer reviewer feedback and submitted the article for final approval. The Channel Curator is responsible for reviewing each submission to ensure the following:</p>

      <ul className='disc indented-for-medium-up'>
        <li>The authors have adequately addressed the peer review comments, making revisions where needed.</li>
        <li>The article is ready for publication from a scientific perspective.</li>
      </ul>

      <p>
        Articles in need of revision must be deferred back to the authors with a complete list of required changes. Articles are then passed to Cureus associate editors where they undergo rigorous editorial review culminating in either approval or rejection. The decision to approve or reject is made independently of the earlier assessment performed by the Channel Curator.
      </p>
    </React.Fragment>

  )

}

export default ChannelEditorialResponsibilities;